import Crud from '../views/Botao/Crud'
import Entity from '../views/Botao/View'

let routes = {
    path: '/botoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/botoes/view/:id?',
            name: 'ViewBotao',
            component: Entity,
            meta: {
                pageTitle: 'Visualizar Botão',
                breadcrumb: [
                    {
                        text: 'Botões',
                        active: false,
                        to: '/botoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/botoes',
            name: 'list-botoes',
            component: Crud,
            meta: {
                pageTitle: "Lista de Botões",
                breadcrumb: [
                    {
                        text: "Botões",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
